import React from "react";
import { AppDataManager } from "../../components/AppData/AppDataManager";

/**
 * Client console: browse and manage the client's app data (global and per-user).
 */
export const AppData = () => <AppDataManager />;

export default AppData;
